import { BehaviorSubject, of, merge, combineLatest, Observable, Subscription, Subject } from 'rxjs';
import { startWith, map, catchError, distinctUntilChanged } from 'rxjs/operators';
import fast_deep_equal from 'fast-deep-equal';
import hash_it from 'hash-it';
import ajv_keywords from 'ajv-keywords'
import ajv, { Ajv } from 'ajv';
import { NIFormData } from './expressions';
import { FormDefinition } from './form';
import { walkData } from './FormVisitor';
import { ExpressionManager } from './ExpressionManager';

// should be covered by types: node in tsconfig, but i don't have it configured correctly
declare const require: any;

var json_pointer = require('json-pointer');

// good to go
/**
 * Track valid state of all fields in evaluation definition.
 */
export class ValidityManager {

  private registry: { [key: string]: Observable<any[]> };
  private error$: BehaviorSubject<any[]>;
  private dataSchemaParserSub: Subscription;
  private validationSubscription: Subscription;
  private validator: null | ajv.ValidateFunction;
  private destroyed = new Subject();
  private ajv: Ajv;

  constructor(form: FormDefinition, expressionManager: ExpressionManager, data$: Observable<NIFormData>) {

    this.error$ = new BehaviorSubject<any[]>([]);

    // this doesn't change when minor version changes @ runtime, does it?
    const i = JSON.parse(JSON.stringify(form.data));

    this.ajv = ajv_keywords(new ajv({
        allErrors: true,
        jsonPointers: true,
        $data: true,
        // validateschema false?
        validateSchema: false
    }));

    const o: {[key: string]: any} = {};

    walkData(form.data, function r(e: { [key: string]: any }, a: any) {
        var n = function(n: string) {
          // var s, u;
          var _ = e[n];
          if (typeof _ === 'object' && _ !== null) {
            if (_.$exp) {
              const l = a + '/' + n;
              const f = hash_it(_.$exp).toString();
              json_pointer.set(i, l, {
                $data: '/' + f
              });
              o[f] = expressionManager.watch(_.$exp)
              .pipe(
                startWith(null),
                map(r => {
                  return ['' + f, r];
                }),
                catchError(_ => {
                  return of([f, null]);
                })
              )
            } else {
              r(_, a + '/' + n)
            }
          } else if (Array.isArray(_)) {
            for (const [h, d] of _.entries()) {
              r(d, a + '/' + n + '/' + h);
            }
          }
        };
        for (var s in e) {
          n(s)
        }
    });

    // this.validator = avj_.compile(i);
    // this.validator = ajv.compile(i);
    this.validator = this.ajv.compile(i);

    var s;

    if (Object.keys(o).length > 0) {
      var u: {[key: string]: any} = {};
      s = merge(...Object.values(o) as any)
        .pipe(
          map((r: any) => {
            const [e, a] = r;
            u[e] = a;
            return u;
          })
        );
    } else {
      s = of({});
    }

    this.dataSchemaParserSub = s.subscribe();

    this.validationSubscription = combineLatest([data$, s])
      .subscribe(r => {
        const [e, i] = r;

        this.validator!(Object.assign(Object.assign({}, e, i)));
        this.error$.next(this.validator!.errors || []);
      });

    this.registry = {};
  }

  public watch(r: string): Observable<ajv.ErrorObject[]>{
    var t;

    if (this.registry[r]) {
      t = this.registry[r]
    } else {

      var e: (t?: string) => boolean;

      if (r === '') {
        e = function() {
          return true;
        }
      } else {
        e = function(t: string | undefined) {
          return Boolean(t === r || (t && t.startsWith(r.concat('/'))));
        }
      }
      t = this.error$.pipe(
        startWith([]),
        map(function(t: any[]) {
          return t.filter(t => {
            if (e(t.dataPath)) {
              return true;
            }

            var a = r.lastIndexOf('/');
            var i = r.substring(0, a);

            if (i !== t.dataPath || t.keyword !== 'required') {
              return false;
            };

            return t.params.missingProperty === r.substring(a + 1);
          })
        }),
        distinctUntilChanged((r, t) => fast_deep_equal(r, t))
      );

      // todo share
      this.registry[r] = t;
    }

    return t;
  };

  reset() {
    this.destroyed.next();
    this.destroyed.complete();
    this.dataSchemaParserSub.unsubscribe();
    this.validationSubscription.unsubscribe();
    this.ajv.removeSchema();
    this.validator = null;
    this.registry = {};
    this.error$.complete();
  };
}
